import { Card, CardContent } from "@/components/ui/card";

interface FilterControlsProps {
  spaceOptions: Array<{ value: string; label: string }>;
  budgetOptions: Array<{ value: string; label: string }>;
  selectedSpace: string;
  selectedBudget: string;
  onSpaceChange: (value: string) => void;
  onBudgetChange: (value: string) => void;
  compact?: boolean;
}

export const FilterControls = ({
  spaceOptions,
  budgetOptions,
  selectedSpace,
  selectedBudget,
  onSpaceChange,
  onBudgetChange,
  compact = false
}: FilterControlsProps) => {
  return (
    <div className={`grid grid-cols-1 ${compact ? 'gap-4' : 'md:grid-cols-2 gap-6'} text-left`}>
      <div>
        <label htmlFor="space-selector" className="block text-sm font-medium mb-3">
          a) Quel espace avez-vous ?
        </label>
        <select 
          id="space-selector"
          className="w-full px-3 py-2 border border-white/20 rounded-md bg-white/10 text-white backdrop-blur-sm"
          value={selectedSpace}
          onChange={(e) => onSpaceChange(e.target.value)}
        >
          {spaceOptions.map((option) => (
            <option 
              key={option.value} 
              value={option.value} 
              className="text-foreground bg-background"
            >
              {option.label}
            </option>
          ))}
        </select>
      </div>
      
      <div>
        <label htmlFor="budget-selector" className="block text-sm font-medium mb-3">
          b) Votre budget ?
        </label>
        <select 
          id="budget-selector"
          className="w-full px-3 py-2 border border-white/20 rounded-md bg-white/10 text-white backdrop-blur-sm"
          value={selectedBudget}
          onChange={(e) => onBudgetChange(e.target.value)}
        >
          {budgetOptions.map((option) => (
            <option 
              key={option.value} 
              value={option.value} 
              className="text-foreground bg-background"
            >
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};